import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { useSessionManager } from "./hooks/useSessionManager"; // ADD THIS IMPORT
import NotificationWrapper from "./components/common/NotificationWrapper"; // FIXED: Aggiunto import
// ==========================================
// TEMA NATALIZIO ARCHIVIATO
// Per riattivare: decommentare la riga seguente e il wrapper <ChristmasThemeProvider> in App()
// ==========================================
// import { ChristmasThemeProvider } from "./components/Christmas/ChristmasThemeProvider";
import MusicPlayerGlobal from "./components/common/MusicPlayerGlobal"; // Player musicale globale
import LoginPage from "./pages/LoginPage";
import TableViewPage from "./pages/TableViewPage";
import ProtectedLayout from "./layout/ProtectedLayout";
import FunzioniAppPage from "./pages/FunzioniAppPage";
import MacroFunzioniPage from "./pages/MacroFunzioniPage";
import ModuliPage from "./pages/ModuliPage";
import GeneratorePage from "./pages/GeneratorePage";
import GeneratorBatchPage from "./features/generatorBatch/GeneratorBatchPage";
import EsxiDashboardPage from "./features/esxi/EsxiDashboardPage";
import TabellePage from "./pages/TabellePage";
import CampiPage from "./pages/CampiPage";
import OggettiPage from "./pages/OggettiPage";
import AttributiPage from "./pages/AttributiPage";
import TipiValidazioniPage from "./pages/TipiValidazioniPage";
import ParametriPage from "./pages/ParametriPage";
import UtentiPage from "./pages/UtentiPage";
import RichiestePage from "./pages/RichiestePage";
import GruppiAbilitazioniPage from "./pages/GruppiAbilitazioniPage";
import AbilitazioniOperazioniPage from "./pages/AbilitazioniOperazioniPage";
import TestModifichePage from "./pages/TestModifichePage"; // AGGIUNTO: Import della nuova pagina
import CalendarTestPage from "./pages/CalendarTestPage";
import CalendarioPage from "./pages/CalendarioPage"; // AGGIUNTO: Import calendario principale

import './index.css';

// ADD THIS COMPONENT
function SessionManagerWrapper({ children }) {
  // Use the session manager hook here
  const sessionManager = useSessionManager();
  
  // You can access session manager functionality if needed:
  // sessionManager.sessionWarning, sessionManager.manualRefresh, etc.
  
  return children;
}

function AppContent() {
  return (
    <SessionManagerWrapper>
      <Routes>
        {/* Rotte Pubbliche */}
        <Route path="/login" element={<LoginPage />} />
        {/* Rotte Protette */}
        <Route element={<ProtectedLayout />}>
          <Route index element={<Navigate to="/sisketron/macrofunzionipage" replace />} />
          
          {/* Sezione Sisketron Core */}
          <Route path="sisketron/macrofunzionipage" element={<MacroFunzioniPage />} />
          <Route path="sisketron/modulipage" element={<ModuliPage />} />
          <Route path="sisketron/tabelle" element={<TabellePage />} />
          <Route path="sisketron/campi" element={<CampiPage />} />
          <Route path="sisketron/oggetti" element={<OggettiPage />} />
          <Route path="sisketron/attributi" element={<AttributiPage />} />
          <Route path="sisketron/tipivalidazioni" element={<TipiValidazioniPage />} />
          <Route path="sisketron/generatore" element={<GeneratorePage />} />
          {/* Nuova pagina batch (Paul-only). Il guard è nel componente stesso. */}
          <Route path="sisketron/generatore-batch" element={<GeneratorBatchPage />} />
          <Route path="gestione/funzioni-app" element={<FunzioniAppPage />} />
          <Route path="sisketron/richieste" element={<RichiestePage />} />
          <Route path="sisketron/testmodifichepage" element={<TestModifichePage />} /> {/* AGGIUNTO: Nuova route */}
          <Route path="sisketron/calendariopage" element={<CalendarioPage />} /> /* AGGIUNTO: Route calendario */
          {/* Dashboard ESXi "Ambienti di test" — accessibile a tutti gli utenti autenticati */}
          <Route path="esxi-dashboard" element={<EsxiDashboardPage />} />
          
          {/* Cruscotto Pages */}
          <Route path="cruscotto/parametri" element={<ParametriPage />} />
          <Route path="cruscotto/utenti" element={<UtentiPage />} />
          <Route path="cruscotto/gruppiabilitazioni" element={<GruppiAbilitazioniPage />} />
          <Route path="cruscotto/abilitazionioperazioni" element={<AbilitazioniOperazioniPage />} />

          {/* Rimuovere o aggiornare se TableViewPage è ancora necessaria */}
          <Route path="tables/:tableName" element={<TableViewPage />} /> 
          <Route path="test/calendar" element={<CalendarTestPage />} />
        </Route>
        {/* Fallback */}
        <Route
          path="*"
          element={
            <Navigate to={localStorage.getItem('authToken') ? "/sisketron/macrofunzionipage" : "/login"} replace />
          }
        />
      </Routes>
    </SessionManagerWrapper>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          {/* ==========================================
              TEMA NATALIZIO ARCHIVIATO
              Per riattivare: decommentare <ChristmasThemeProvider> e </ChristmasThemeProvider>
              e l'import in cima al file
              ========================================== */}
          {/* <ChristmasThemeProvider> */}
            <NotificationWrapper>
              <AppContent />
              <MusicPlayerGlobal /> {/* Player globale persistente */}
            </NotificationWrapper>
          {/* </ChristmasThemeProvider> */}
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
